var map = {
	"./about-us.png": 7402,
	"./careers.png": 5249,
	"./certificates.png": 2190,
	"./cloud.png": 383,
	"./colocation.png": 9421,
	"./consultation.png": 5953,
	"./engineers.png": 8418,
	"./hardware.png": 2006,
	"./linux.png": 4798,
	"./microsoft.png": 8572,
	"./partners.png": 2867,
	"./priLogo.png": 9162,
	"./security.png": 4200,
	"./server-white-bg.png": 9167,
	"./server.png": 1239,
	"./software.png": 345,
	"./storage.png": 6631,
	"./switches.png": 8334,
	"./testimonials.png": 7786,
	"./vps.png": 2249,
	"./web-panel.png": 7399
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7316;